import { useCompany, useCompanyPayments } from '@/services'
import { UserProfile } from '@/types/user-profile'
import { ReactElement } from 'react'
import { useOutletContext } from 'react-router-dom'
import { StepContainer } from '../../styles'
import {
  ChecklistStepperProvider,
  useChecklistStepper,
} from './hooks/useChecklistStepper'
import { useStableSteps } from './hooks/useStableSteps'
import { LoadingSkeleton } from './components'
import { ModalBase } from '@/components/molecules/ModalBase'

interface BusinessInformationFlowProps {
  isOpen: boolean
  onClose: () => void
  companyId: string
}

interface OutletContext {
  user: UserProfile
}

const StepContent = ({ steps }: { steps: ReactElement[] }) => {
  const { currentStep } = useChecklistStepper()

  return <StepContainer>{steps[currentStep]}</StepContainer>
}

export const BusinessInformationFlow = ({
  isOpen,
  onClose,
  companyId,
}: BusinessInformationFlowProps): ReactElement => {
  const { data: company, isLoading: isCompanyLoading } = useCompany(companyId)
  const { user } = useOutletContext<OutletContext>()
  const {
    data: paymentMethods = [],
    isLoading: isPaymentMethodsLoading,
  } = useCompanyPayments(companyId)

  const steps = useStableSteps({
    company,
    companyId,
    user,
    paymentMethods,
    isCompanyLoading,
    isPaymentMethodsLoading,
  })

  const isLoading = isCompanyLoading || isPaymentMethodsLoading

  return (
    <ModalBase isOpen={isOpen} onClose={onClose} closable padding="0">
      {isLoading ? (
        <LoadingSkeleton />
      ) : (
        <ChecklistStepperProvider
          totalSteps={steps.length}
          initialStep={0}
          onFinish={onClose}
        >
          <StepContent steps={steps} />
        </ChecklistStepperProvider>
      )}
    </ModalBase>
  )
}
